import React from "react";
import { Form, Select } from "antd";
import PhoneNumberMask from "../../../../common/inputs/AuthorizationInputs";

const Phone = ({ form, disabled, labelCol, wrapperCol }) => {
  const { getFieldDecorator } = form;
  const { Option } = Select;
  const prefixPhoneCode = getFieldDecorator("phone_code", {
    initialValue: "+7"
  })(
    <Select
      style={{ width: 78, backgroundColor: "#fff" }}
      dropdownMatchSelectWidth={false}
      optionLabelProp="value"
      placeholder="Код"
      disabled={disabled}
    >
      <Option value="+7">+7 (Россия)</Option>
      <Option value="+380">+380 (Украина)</Option>
      <Option value="+375">+375 (Беларусь)</Option>
      <Option value="+77">+77 (Казахстан)</Option>
      <Option value="+994">+994 (Азербайджан)</Option>
      <Option value="+374">+374 (Армения)</Option>
      <Option value="+995">+995 (Грузия)</Option>
    </Select>
  );

  return (
    <>
      <Form.Item
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        label="Телефон"
        className="phone-input"
        style={{marginBottom: 10}}
      >
        {getFieldDecorator("phone_number")(
          <PhoneNumberMask
            addonBefore={prefixPhoneCode}
            autoComplete="off"
            name="phoneNumber"
            mask="(###) ###-##-##"
            maxLength={15}
            disabled={disabled}
            placeholder="Укажите номер телефона"
            style={{ width: 320}}
          />
        )}
      </Form.Item>
    </>
  );
};

export default Phone;
